<template>
  <div
    v-show="$parent.chat"
    class="position-relative chat-holder">
    <div
      v-if="chatType === '' && !showMobileInvite"
      class="panel">
      <div class="mb-2 d-none d-md-flex ml-2">
        <span class="mr-auto fs14"><b class="align-middle"> {{ $t('MEETING.CHAT_MEETING_CHATS') }}</b></span>
        <span
          :class="{ disabled: isPrivateChatDisabled }"
          class="ml-auto">
          <plus-box-icon
            id="startChat"
            :size="24"
            class="align-middle cursor"
            @click="$refs.privateChatModal.show()"/>
        </span>
      </div>
      <b-tooltip
        v-if="!$parent.$parent.isMobile()"
        target="startChat"
        boundary="window"
        triggers="hover">{{ $t('MEETING.CHAT_START_PRIVATE_CHAT') }}</b-tooltip>
      <div class="mobileHeader align-items-center shadow d-flex flex-row justify-content-between p-4">
        <close-icon
          class="cursor"
          @click="toggleChat()"/>
        <span class=" fs14"><b>{{ $t('MEETING.CHAT_MEETING_CHATS') }}</b></span>
        <plus-box-icon
          :size="24"
          :class="{ disabled: isPrivateChatDisabled }"
          class="align-middle cursor"
          @click="showMobileInvite = true"/>
      </div>
      <perfect-scrollbar>
        <ul class="list-unstyled">
          <li
            v-if="!isPublicChatDisabled"
            class="d-flex align-items-center  flex-row justify-content-between"
            @click="chatType = 'everyone'; everyoneChatCount = 0">
            <div class="d-flex">
              <div class="dot">
                <account-group-icon
                  :size="20"
                  class="align-middle bump"
                />
              </div>
              <div class="d-flex flex-column name">
                {{ $t('MEETING.CHAT_PUBLIC') }}
              </div>
            </div>
            <div class="d-flex">
              <b-badge
                v-if="everyoneChatCount > 0 "
                class="chat-count"
                variant="danger">{{ everyoneChatCount }}</b-badge>
            </div>
          </li>
          <li
            v-for="(object, index) in privateChats"
            :key="index"
            :class="{ disabled: isPrivateChatDisabled }"
            class="d-flex align-items-center  flex-row justify-content-between"
            @click="startPrivateChat(object.user)">
            <div class="d-flex">
              <name-dot
                :first-name="object.user.firstName"
                :last-name="object.user.lastName"/>
              <img
                v-if="object.user.image"
                :src="object.user.image"
                class="img d-flex">
              <div class="d-flex flex-column name">
                {{ object.user.firstName }} {{ object.user.lastName }}
              </div>
            </div>
            <b-badge
              v-if="object.newChats > 0 "
              class="chat-count"
              variant="danger">{{ object.newChats }}</b-badge>
          </li>
        </ul>
      </perfect-scrollbar>
    </div>
    <div
      v-if="chatType === 'everyone'"
      class="panel">
      <div class="mb-2 d-none d-md-flex">
        <span class="mr-auto position-relative hover-big cursor">
          <chevron-left-icon
            :size="24"
            class="align-middle cursor"
            @click="chatType = ''; showMobileInvite = false"/>
          <span
            v-if="privateChatCount > 0"
            class="boop"/>
        </span>
        <span class="m-auto fs14"><b class="align-middle">{{ $t('MEETING.CHAT_PUBLIC') }}</b></span>
        <span
          :size="24"
          class="ml-auto"/>
      </div>
      <div class="mobileHeader align-items-center shadow d-flex  flex-row justify-content-between p-4">
        <span class="mr-auto position-relative hover-big cursor">
          <chevron-left-icon
            :size="24"
            class="align-middle cursor position-relative hover-big"
            @click="chatType = ''"/>
          <span
            v-if="privateChatCount > 0"
            class="boop"/>
        </span>
        <span class="fs14"><b>{{ $t('MEETING.CHAT_PUBLIC') }}</b></span>
        <close-icon
          class="ml-auto"
          @click="toggleChat()"/>
      </div>
      <div
      class="chatContainer">
        <perfect-scrollbar ref="chatArea">
          <div
            v-for="(chat, index) in chats"
            :class="{other: !chat.self, 'mt-auto': index === 0 }"
            :key="index"
            class="message">
            <div class="d-flex flex-column justify-content-end message-aligner">
              <div>
                <span
                  v-if="!chat.self
                    && (chats[index - 1] && chats[index - 1].srcIM.userID !== chat.srcIM.userID
                    || typeof chats[index - 1] == 'undefined'
                  )"
                  class="who d-block fs12 mt-2">{{ chat.srcIM.firstName }} {{ chat.srcIM.lastName }}</span>
              </div>
              <div class="bubble-holder d-flex align-items-center flex-row-reverse">
                <div
                  class="bubble rounded fs14 position-relative"
                  v-html="chat.IMMsg"/>
                <span
                  :class="{'visible-md-down': (chats[index + 1] && chats[index + 1].srcIM.userID !== chat.srcIM.userID || typeof chats[index + 1 ] == 'undefined')}"
                  class="time fs12">{{ chat.time }}</span>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
      <div class="form-label-group inputHolder">
        <b-input
          id="chat-type"
          ref="chatInputEveryone"
          :disabled="isPublicChatDisabled"
          v-model="chatMessage"
          :placeholder="isPublicChatDisabled ? $t('MEETING.CHAT_DISABLED') : $t('MEETING.CHAT_PLACEHOLDER')"
          onfocus="this.original = this.placeholder; this.placeholder = ''"
          onblur="this.placeholder = this.original"
          class="chat-input"
          type="text"
          autocomplete="off"
          @keydown.native="pressedEnter"/>
        <label
          class="chatLabel"
          for="chat-type">{{ isPublicChatDisabled ? $t('MEETING.CHAT_DISABLED') : $t('MEETING.CHAT_PLACEHOLDER') }}</label>
      </div>
    </div>
    <div
      v-if="chatType === 'private' && selectedPerson !== null"
      class="panel">
      <div class="mb-2 d-none d-md-flex">
        <span class="mr-auto position-relative cursor hover-big">
          <chevron-left-icon
            :size="24"
            class="align-middle cursor"
            @click="chatType = ''; selectedPerson = null"/>
          <span
            v-if="everyoneChatCount > 0"
            class="boop"/>
        </span>
        <span class="m-auto fs14"><b
        class="align-middle">{{ selectedPerson.firstName }} {{ selectedPerson.lastName }}</b></span>
        <span
          :size="24"
          class="ml-auto"/>
      </div>
      <div class="mobileHeader align-items-center shadow d-flex  flex-row justify-content-between p-4">
        <span class="mr-auto position-relative hover-big cursor">
          <chevron-left-icon
            :size="24"
            class="align-middle cursor"
            @click="chatType = ''; showMobileInvite = false; selectedPerson = null"/>
          <span
            v-if="everyoneChatCount > 0"
            class="boop"/>
        </span>
        <span class="fs14"><b>{{ selectedPerson.firstName }} {{ selectedPerson.lastName }}</b></span>
        <close-icon
          class="ml-auto"
          @click="toggleChat()"/>
      </div>
      <div
      class="chatContainer">
        <perfect-scrollbar ref="chatArea">
          <div
            v-for="(chat, index) in privateChats[selectedPerson.id.toString()].chats"
            :class="{other: !chat.self, 'mt-auto': index === 0 }"
            :key="index"
            class="message">
            <div class="d-flex flex-column justify-content-end message-aligner">
              <div class="bubble-holder d-flex align-items-center flex-row-reverse">
                <div
                  class="bubble rounded fs14 position-relative"
                  v-html="chat.msg"/>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
      <div class="form-label-group inputHolder">
        <b-input
          id="privatechat"
          ref="chatInputPrivate"
          :disabled="isPrivateChatDisabled"
          v-model="privateChatMessage"
          :placeholder="$t('MEETING.CHAT_MESSAGE') + ' ' + selectedPerson.firstName + ' ' + selectedPerson.lastName"
          class="chat-input"
          type="text"
          autocomplete="off"
          @keydown.native="pressedEnterPrivate"/>
        <label
          class="chatLabel"
          for="privatechat">{{ $t('MEETING.CHAT_MESSAGE') }} {{ selectedPerson.firstName }} {{ selectedPerson.lastName }}</label>
      </div>
    </div>
    <div
      v-if="chatType === '' && showMobileInvite"
      class="panel privateModal">
      <div class="mobileHeader align-items-center shadow d-flex  flex-row justify-content-between p-4">
        <chevron-left-icon
          :size="24"
          class="align-middle cursor"
          @click="chatType = ''; showMobileInvite = false"/>
        <span class=" fs14"><b>{{ $t('MEETING.CHAT_START_PRIVATE_CHAT') }}</b></span>
        <close-icon @click="toggleChat()"/>
      </div>
      <b-form-input
        v-model="text"
        placeholder="Search Contacts"/>
      <div >
        <perfect-scrollbar class="mt-4">
          <ul
          class="list-unstyled">
            <li
              v-for="(person, index) in privateList"
              :key="index"
              :class="{ disabled: isPrivateChatDisabled }"
              class="d-flex align-items-center flex-row justify-content-between"
              @click="startPrivateChat(person)">
              <div class="d-flex">
                <name-dot
                  :first-name="person.firstName"
                  :last-name="person.lastName"/>
                <img
                  v-if="person.image"
                  :src="person.image"
                  class="img d-flex">
                <div class="d-flex flex-column name">
                  {{ person.firstName }} {{ person.lastName }}
                </div>
              </div>
            </li>
          </ul>
        </perfect-scrollbar>
      </div>
    </div>
    <b-modal
      v-if="$parent.$refs.sidePart"
      id="private-modal"
      ref="privateChatModal"
      :hide-header="true"
      :hide-footer="true"
      :cancel-disabled="true"
      body-class="privateModal"
      @change="clearSearch()"
    >
      <div>
        <div class="mb-3 d-flex align-items-center flex-row justify-content-between">
          <h4 class="m-0">{{ $t('MEETING.CHAT_START_PRIVATE_CHAT') }}</h4>
          <close-icon
            class="cursor"
            @click="$refs.privateChatModal.hide()"/>
        </div>
        <b-form-input
          v-model="text"
          placeholder="Search Contacts"/>
        <div >
          <perfect-scrollbar class="mt-4">
            <ul
            class="list-unstyled">
              <li
                v-for="(person, index) in privateList"
                :key="index"
                :class="{ disabled: isPrivateChatDisabled }"
                class="d-flex align-items-center flex-row justify-content-between"
                @click="startPrivateChat(person)">
                <div class="d-flex">
                  <name-dot
                    :first-name="person.firstName"
                    :last-name="person.lastName"/>
                  <img
                    v-if="person.image"
                    :src="person.image"
                    class="img d-flex">
                  <div class="d-flex flex-column name">
                    {{ person.firstName }} {{ person.lastName }}
                  </div>
                </div>
              </li>
            </ul>
          </perfect-scrollbar>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {ref, computed, watch} from "@vue/composition-api"
import ChevronLeftIcon from "icons/ChevronLeft"
import AccountGroupIcon from "icons/AccountGroup"
import PlusBoxIcon from "icons/PlusBox"
import CloseIcon from "icons/Close"
import {PerfectScrollbar} from 'vue2-perfect-scrollbar'
import sanitizeHtml from 'sanitize-html';
import NameDot from "./NameDot"
import { gaEvent } from "../functions/gtag"

export default {
  name: 'ChatSide',
  components: {
    NameDot,
    ChevronLeftIcon,
    AccountGroupIcon,
    PlusBoxIcon,
    CloseIcon,
    PerfectScrollbar
  },
  setup(props, context) {
    const chatMessage = ref('')
    const everyoneChatCount = ref(0)
    const privateChatCount = ref(0)
    const privateChatMessage = ref('')
    const selectedChat = ref(null)
    const selectedPerson = ref(null)
    const text = ref('')
    const chats = ref([])
    const showMobileInvite = ref(false)
    var privateChats = {}
    const chatType = ref('everyone')
    const publicChat = ref({value: "public", name: context.root.$t('MEETING.CHAT_PUBLIC'), newMsg: 0})
    const dateLastUpdate = ref("")
    var shouldScroll = false

    const totalChat = computed( () => {return everyoneChatCount.value + privateChatCount.value })
    const privateList = computed(() => {
      if (text.value) {
        return context.parent.$refs.sidePart.participantList.filter(user => user.firstName.toLowerCase().includes(text.value.toLowerCase()) && user.isSelf !== true)
      } else if (context.parent.$refs.sidePart.participantList) {
        return context.parent.$refs.sidePart.participantList.filter(user => user.isSelf !== true)
      } else {
        return []
      }
    })
    const isPrivateChatDisabled = computed(() => {
      if (context.parent.$parent.getChatOptions(1, context.parent.$parent.meetingChatOption)) {
        if(chatType.value == 'private') chatType.value = ""
        return true
      } else if (context.parent.$refs.sidePart && (!context.parent.$refs.sidePart.amImoderator == true && !context.parent.$refs.sidePart.amIspeaker == true) &&
          (context.parent.$parent.getChatOptions(2, context.parent.$parent.meetingChatOption) || context.parent.$parent.getChatOptions(4, context.parent.$parent.meetingChatOption))) {
        if(chatType.value == 'private') chatType.value = ""
        return true
      }
      return false
    })
    const isPublicChatDisabled = computed(() => {
      if (context.parent.$parent.getChatOptions(8, context.parent.$parent.meetingChatOption)) {
        if(chatType.value == 'everyone') chatType.value = ""
        return true
      } else if (context.parent.$refs.sidePart && (!context.parent.$refs.sidePart.amImoderator == true && !context.parent.$refs.sidePart.amIspeaker == true) &&
          (context.parent.$parent.getChatOptions(16, context.parent.$parent.meetingChatOption) || context.parent.$parent.getChatOptions(32, context.parent.$parent.meetingChatOption))) {
        if(chatType.value == 'everyone') chatType.value = ""
        return true
      }
      return false
    })

    function beep() {
      if (context.parent.$parent.getItem('beepMessage') == undefined || context.parent.$parent.getItem('beepMessage')) {
        let snd = new Audio("data:audio/wav;base64,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")
        snd.play()
      }
    }

    function startPrivateChatPopup() {
      alert('open popup')
    }

    function toggleChat() {
      context.parent.$parent.expanded = !context.parent.$parent.expanded
      context.parent.chat = !context.parent.chat
    }

    function sendMessage() {
      let text = chatMessage.value
      chatMessage.value = ''
      let len = text.length
      if (len > 16384) {
        text = text.substr(0, 16384)
        text += "...( + ' + (len-16384) + ' chars)"
      }

      let eventHandlers = {
        'succeeded': E => null,
        'failed': E => null
      }

      let options = {
        'eventHandlers': eventHandlers
      }

      if (selectedChat.value != "public") {
        options.extraHeaders = ['Vibe-Privatechat: ' + selectedChat.value]
      }

      let destination
      if (context.root.$route.query.meetingID) {
        if (context.root.$route.query.pin) {
          destination = (context.root.$route.query.meetingID + context.root.$route.query.pin)
        } else {
          destination = context.root.$route.query.meetingID
        }
      } else if (context.parent.$parent.meetingData.meetingID) {
        if (context.parent.$parent.meetingData.pin) {
          destination = (context.parent.$parent.meetingData.meetingID + context.parent.$parent.meetingData.pin)
        } else {
          destination = context.parent.$parent.meetingData.meetingID
        }
      } else {
        return
      }

      if (selectedChat.value != null) {
        if (text.trim().length > 0) {
          gaEvent({'ACTION': 'action', 'video_chat': 'sent'});
        }
        context.parent.$parent.webrtcPhone.sendMessage(destination, text, options)
      }
    }

    function sendPrivateMessage(){
      let dateObject = new Date()
      let time = dateObject.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      })
      let text = privateChatMessage.value
      privateChatMessage.value = ''
      let len = text.length
      if (len > 16384) {
        text = text.substr(0, 16384)
        text += "...( + ' + (len-16384) + ' chars)"
      }

      if (text.trim().length > 0) {
          gaEvent({'ACTION': 'action', 'video_chat': 'sent'});
      }
      context.parent.$parent.webrtcMeta.send(JSON.stringify({
        d_type: "WSChat",
        chatType: 'USER',
        dest: selectedPerson.value.id,
        from: context.parent.$parent.metaUserInfo,
        msg: text,
        timeStamp: Date.now()
      }))
      privateChats[selectedPerson.value.id.toString()].chats.push(
        {
          self: true,
          from: context.parent.$parent.metaUserInfo,
          msg: text,
          timeStamp: time
        }
      )
      shouldScroll = true
    }

    function processMessage(message) {
      let dateObject = new Date(message.timestamp)
      message.time = dateObject.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      });
      if (message.IMMsg && message.IMMsg !== '') {
        if (sanitizeHtml(message.IMMsg).length > 0) {
          message.IMMsg = message.IMMsg.replace(/href/g, "target='_blank' href")
          message.IMMsg = sanitizeHtml(message.IMMsg, {disallowedTagsMode: 'escape'})
          chats.value.push(message);
          shouldScroll = true
        } else {
          return
        }
      } else {
        return
      }
      // if not on tab or if tab is open your not on everybody
      if (chatType.value !== 'everyone' || (chatType.value === 'everyone' && selectedPerson.value == null && !context.parent.chat)) {
        everyoneChatCount.value += 1
        beep()
      }
    }

    function processPrivateMessage(message) { //TODO: Move rest of chat off old websocket
      if (message.msg && message.msg !== '' && message.chatType !== 'ROOM') {
        if (sanitizeHtml(message.msg).length > 0) {
          message.msg = message.msg.replace(/href/g, "target='_blank' href")
          message.msg = sanitizeHtml(message.msg, {disallowedTagsMode: 'escape'})
          if (!privateChats[message.from.id.toString()]) {
            privateChats[message.from.id.toString()] = {"user": message.from, "chats": [], "newChats": 0}
          }
          privateChats[message.from.id.toString()].chats.push(message)
          shouldScroll = true
        } else {
          return
        }
      } else {
        return
      }
      // if not on tab or if tab is open your not on that person
      if (selectedPerson.value === null || selectedPerson.value.id !== message.from.id) {
        privateChats[message.from.id.toString()].newChats += 1
        privateChatCount.value += 1
        beep()
      }
    }

    function scrollToEnd(ca) {
      // scroll to the start of the last message in case it's a really long one, so we land on top
      var el = ca.$el
      var messages = el.getElementsByClassName('message')
      if (messages.length) {
        var last = messages.item(messages.length - 1)
        var fromSelf = !last.classList.contains('other')
        var newTop = fromSelf ? el.scrollHeight : last.offsetTop - 10
        el.scrollTop = !shouldScrollToEnd(el) ? el.scrollTop : newTop
      }
      shouldScroll = false
    }

    function shouldScrollToEnd(el) {
      if (!shouldScroll) return false
      var messages = el.getElementsByClassName('message') ? el.getElementsByClassName('message') : []
      if (messages.length) {
        if (messages.length < 2) return false
        var lastMessage = messages.item(messages.length - 1)
        var penultimateMessage = messages.item(messages.length - 2)
        var bothHeight = lastMessage.scrollHeight + penultimateMessage.scrollHeight + 10
        var fromSelf = !lastMessage.classList.contains('other')
        var penultimateWasVisible = el.scrollHeight - el.scrollTop - el.offsetHeight <= bothHeight
        return fromSelf || penultimateWasVisible
      }
      return false;
    }

    function pressedEnter(e) {
      if (e.keyCode === 13) {
        sendMessage()
      }
    }
    function pressedEnterPrivate(e) {
      if (e.keyCode === 13) {
        sendPrivateMessage()
      }
    }

    function clearSearch(){
      text.value = ""
    }

    function startPrivateChat(person) {
      selectedPerson.value = person
      chatType.value = 'private'
      if (!privateChats[person.id.toString()]) {
        privateChats[person.id.toString()] = {"user": person, "chats": [], "newChats": 7}
      }
      context.refs.privateChatModal.hide()
      text.value = ""
    }

    const isDisabledChat = computed(() => {
      if (selectedChat.value == null) {
        return true
      } else {
        if (context.parent.$parent.meetingInfo && (context.parent.$parent.meetingInfo.options.includes('chat=16') || context.parent.$parent.meetingInfo.options.includes('chat=20'))) {
          return true
        } else {
          return false
        }
      }
    })

    watch(selectedPerson, (value, oldValue) => {
      if(value){
        privateChatCount.value -= privateChats[value.id.toString()].newChats
        privateChats[value.id.toString()].newChats = 0
      }
    })

    watch(chatType, (value, oldValue) => {
      if(value){
        if (value === 'everyone')
          setTimeout( () => context.refs.chatInputEveryone.$el.focus(), 100)
        else if (value === 'private')
          setTimeout( () => context.refs.chatInputPrivate.$el.focus(), 100)
      }
    })

    return {
      dateLastUpdate,
      chatMessage,
      privateChatMessage,
      sendMessage,
      pressedEnter,
      publicChat,
      selectedChat,
      sendPrivateMessage,
      isDisabledChat,
      chats,
      processMessage,
      toggleChat,
      privateChats,
      startPrivateChat,
      selectedPerson,
      isPrivateChatDisabled,
      isPublicChatDisabled,
      chatType,
      privateList,
      clearSearch,
      pressedEnterPrivate,
      showMobileInvite,
      processPrivateMessage,
      totalChat,
      everyoneChatCount,
      privateChatCount,
      text,
      scrollToEnd,
      shouldScroll
    }
  },
  updated() {
     var area = this.$parent.$refs.chatArea ? this.$parent.$refs.chatArea : this.$refs.chatArea
     if (area) {
       this.$nextTick(() => this.scrollToEnd(area));
     }
  }
}
</script>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
<style>
.privateModal input {
  border-radius: 0;
  border: 0;
  outline: 0;
  font-size: 25px;
  line-height: 35px;
  color: #BBBBBB;
  border-bottom: 3px solid #2491FF;
  padding: 0px !important;
}

.privateModal input:hover, .privateModal input:focus {
  border-bottom: 3px solid #2491FF;
}
</style>
<style scoped>
ul{
  max-height: 250px
}
li{
  height: 48px;
  cursor: pointer;
  padding-left: 12px;
  border-radius: 4px;
}
li:hover{
background-color: #363636;
}
.participantsContainer{
  margin: 24px;
}
li .img{
  border-radius: 100%;
  width: 32px;
  margin-right: 12px;
}
.name{
  font-weight: 600;
  font-size: 14px;
  line-height: 30px;
}
.badge{
  font-weight: 700;
  height: 23px;
  margin-left: 11px;
  width: 23px;
  text-align: center;
  line-height: 16px;
}
.dot{
  border-radius: 100%;
  background: #535353;
  font-size: 12px;
  font-weight: 600;
  width: 32px;
  height: 32px;
  margin-right: 12px;
  line-height: 32px;
  text-align: center;
}
.boop{
  border-radius: 100%;
  background: #e72113;
  width: 6px;
  height: 6px;
  position: absolute;
  top: 3px;
  right: 2px;
}
.hover-big:hover{
  background-color: #4A4A4A;
  border-radius: 100%;
}
.bump{
  top:-2px;
}
.disabled {
  pointer-events:none;
  opacity:0.6;
}
</style>





// WEBPACK FOOTER //
// src/components/ChatSideBar.vue